import React from 'react';
import { Route } from 'react-router-dom';
// eslint-disable-next-line no-unused-vars
import MasterTableChild from './MasterTableChild';
import OtherAsset from './OtherAsset';
import { MasterTableType } from '../../const';


export default function MasterTable({ match }) {
    return (
        <div className="content">
            <div className="container-fluid">
                <Route path={`${match.url}/party-type`} component={() => <MasterTableChild type={MasterTableType.party_type} title="Party Type" />} />
                <Route path={`${match.url}/business-sector`} component={() => <MasterTableChild type={MasterTableType.business_sector} />} />
                <Route path={`${match.url}/loan-purpose-type`} component={() => <MasterTableChild type={MasterTableType.party_type} title="Loan Purpose Type" />} />
                <Route path={`${match.url}/collateral-master`} component={() => <MasterTableChild type={MasterTableType.party_type} title="Collateral Type" />} />
                <Route path={`${match.url}/product-type`} component={() => <MasterTableChild type={MasterTableType.party_type} title="Product Type" />} />
                <Route path={`${match.url}/capital-buffer`} component={() => <OtherAsset type={MasterTableType.party_type} />} />
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/pages/MasterTable/index.js